import { AxiosArgs, ThenArgs } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeBody } from 'src/api/client';

type DeleteModifiers = (a: {
  scenario_id: string;
  control_id: string;
  modifiers: { id: string }[];
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse<unknown>>>>;

export const deleteModifiers: DeleteModifiers = (data) => {
  const path = `/api/public/api/modifiers`;
  return axios({
    method: 'DELETE',
    url: path,
    data: encodeBody(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------
